module.exports = __webpack_public_path__ + "img/21.51c4f180.jpg";